module.exports = __webpack_public_path__ + "img/5.bd483bf1.jpg";